// removed by extract-text-webpack-plugin
module.exports = {"select":"magazines_ZFYzr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontFamily/styles.scss
// module id = 1069
// module chunks = 1